import { Query } from '@tanstack/react-query';
import { useToasterContext } from '@/shared/context/ToasterContext.tsx';
import { useTranslation } from 'react-i18next';
import { captureException } from '@sentry/react';
import { getErrorMessage } from '../utils/errorMessage';

export const useQueryErrorHandler = () => {
    const { addToast } = useToasterContext();
    const { t } = useTranslation();

    return {
        handleCacheErrors: {
            onError: (error: unknown, query: Query<unknown, unknown, unknown>) => {
                if (query?.meta?.preventGlobalError) {
                    return;
                }

                addToast({
                    title: t('errorMessages.api.requestErrorTitle'),
                    message: getErrorMessage(error),
                    type: 'error',
                    closable: true,
                });

                captureException(error);
            },
        },
        handleMutationErrors: {
            onError: (error: unknown) => {
                addToast({
                    title: t('errorMessages.api.requestErrorTitle'),
                    message: getErrorMessage(error),
                    type: 'error',
                    closable: true,
                });

                captureException(error);
            },
        },
    };
};
